Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.SessionBarChartListItemViewFactory
  constructor: (title, description, dimension) ->
    @title = title
    @description = description
    @dimension = dimension

  canHandle: (configuredCharts, session) ->
    widgetDimensions = session.getWidgetCollection().map((widget) -> widget.get('dimension'))
    !widgetDimensions.includes(@dimension)

  create: (session) ->
    new Common.Dashboard.Charts.SessionBarChartListItemView(@title, @description, @dimension, session)
